import * as React from "react";
import { Tab, Tabs } from "carbon-components-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { AppShape } from "@eave/shared/types/api";
import { setCurrentHurdleName } from "web_modules/underwriter_dashboard/actions";

const DocumentTitle = require("react-document-title");
const capitalize = require("underscore.string/capitalize");

const styles = require("./styles.module.scss");

export interface HurdleTab {
  label: string;
  link: string;
  name: string;
  component: React.ComponentType;
}

interface Props {
  app: AppShape;
  onHide: Function;
  groupName: string;
  tabs: HurdleTab[];
  link: string;

  // TODO: jjw: could get these via useDispatch after upgrading react-redux
  setCurrentHurdleName?: Function;

  // withRouter
  history: any;
  location: any;
  match: any;
}

const url = (appId: number, groupName: string, link: string) =>
  `/underwriter/app/${appId}/${groupName}/${link}`;

const HurdleTabGroup: React.FC<Props> = ({
  app,
  onHide,
  groupName,
  tabs,
  link,
  setCurrentHurdleName,
  history,
}) => {
  const [currIdx, setCurrIdx] = React.useState<null | number>(null);

  React.useEffect(() => {
    const linkIdx = tabs.findIndex(t => t.link === link);
    if (linkIdx === -1) {
      setCurrIdx(0);
      history.push(url(app.id, groupName, tabs[0].link));
    } else {
      setCurrIdx(linkIdx);
    }
  }, [app.id, groupName, history, link, tabs]);

  let title;
  if (currIdx === null) {
    title = `#${app.id}: ${capitalize(groupName)}`;
  } else {
    title = `#${app.id}: ${tabs[currIdx].label}`;
    setCurrentHurdleName(tabs[currIdx].name);
  }

  return (
    <DocumentTitle title={title}>
      <>
        <div className={styles.tabHeader}>
          <div className={styles.groupName}>
            <h3>{capitalize(groupName)}</h3>
          </div>
        </div>
        {currIdx !== null && (
          <Tabs
            selected={currIdx}
            onSelectionChange={(idx: number) => setCurrIdx(idx)}
            className={styles.tabs}
          >
            {tabs.map(tab => {
              const { label, link, name, component } = tab;

              const href = url(app.id, groupName, link);

              const hurdle = app.hurdles.find(h => h.name === name);
              const props: any = { app, hurdle, onHide, hideTitle: true };

              return (
                <Tab
                  key={name}
                  id={`tab-${name}`}
                  label={label}
                  href={href}
                  onClick={() => history.push(href)}
                >
                  {React.createElement(component, props, null)}
                </Tab>
              );
            })}
          </Tabs>
        )}
      </>
    </DocumentTitle>
  );
};

const mapDispatchToProps = dispatch => ({
  setCurrentHurdleName: (hurdleName: string) => dispatch(setCurrentHurdleName(hurdleName)),
});

const ConnectedHurdleTabGroup = connect<any, any>(null, mapDispatchToProps)(HurdleTabGroup);

export default withRouter(ConnectedHurdleTabGroup);
